import { Action, initialState, State } from 'store/store';

export const audioAcknowledged = (
  state: State = initialState,
  { data }: Action
): State => {
  console.log('audioAcknowledged :', data);

  const nextState = {
    ...state,
    audioAcknowledged: data as any,
  };

  return nextState;
};
